module.exports = __webpack_public_path__ + "img/article_8_1.a4a633d2.png";